"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkillListStyled = void 0;
const constants_1 = require("../../theme/constants");
exports.SkillListStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;

  >.skills {
    @media (min-width: ${constants_1.sizes.tablet}) {
      columns: 3;
    }

    @media (min-width: ${constants_1.sizes.mobile}) and (max-width: ${constants_1.sizes.tablet}) {
      columns: 2;
    }

    @media (max-width: ${constants_1.sizes.mobile}) {
      columns: 1;
    }
  }
}
`;
//# sourceMappingURL=SkillList.styled.js.map